import * as React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useNotification } from "../services/Notifications";
import { noticeMessageFor, withoutNotice } from "../util/notices";

export default function UrlNotice() {
  const location = useLocation();
  const history = useHistory();
  const notify = useNotification();
  const message = noticeMessageFor(
    new URLSearchParams(location.search).get("notice"),
  );

  React.useEffect(() => {
    if (!message) return;
    notify({ message });
    history.replace({ ...location, search: withoutNotice(location.search) });
  }, [message, notify, history, location]);

  return null;
}
